import { useCallback, useEffect, useState } from 'react';
export const useOnDelayedHover = (onHover, delay = 100, disabled = false) => {
  const [isActiveId, setIsActiveId] = useState(null);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (disabled) setIsActiveId(null);
  }, [disabled]);
  useEffect(() => {
    if (isActiveId) {
      const timeoutId = setTimeout(() => {
        onHover(isActiveId);
      }, delay);
      return () => clearTimeout(timeoutId);
    }
  }, [isActiveId, onHover, delay]);
  const onMouseEnter = useCallback(e => {
    if (!disabled) setIsActiveId(e.currentTarget.id);
  }, [disabled]);
  const onMouseLeave = useCallback(() => {
    setIsActiveId(null);
  }, []);
  const onFocus = useCallback(e => {
    if (!disabled) setIsActiveId(e.currentTarget.id);
  }, [disabled]);
  const onBlur = useCallback(() => {
    setIsActiveId(null);
  }, []);
  return {
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  };
};